module.exports = __webpack_public_path__ + "img/sea-breeze.4ebcc5be.jpg";